module.exports = __webpack_public_path__ + "img/logo_start.217c254d.svg";